var exports = {
  "x6": "xf0b3b88a--f67322--button",
  "Kk": "xf0b3b88a--f67322--icon",
  "s5": "xf0b3b88a--f67322--icon--active",
};

module.exports = exports;
